import type { ColumnDef } from '@tanstack/react-table';

import { GetTotemCashHistoryQuery } from 'data/__generated__';
import { DataTable, dateColumn, textColumn, numberColumn } from 'components/DataTable';

type CashCreditRow = GetTotemCashHistoryQuery['totemCashHistory']['credits'][number];

const columns: ColumnDef<CashCreditRow, unknown>[] = [
    dateColumn<CashCreditRow, Record<string, unknown>>({
        accessorKey: 'createdAt',
        header: 'Date de création',
        defaultVisible: true,
    }),
    dateColumn<CashCreditRow, Record<string, unknown>>({
        accessorKey: 'updatedAt',
        header: 'Dernière mise à jour',
        defaultVisible: true,
    }),
    textColumn<CashCreditRow, Record<string, unknown>>({
        accessorKey: 'name',
        header: 'Nom du crédit',
        defaultVisible: true,
    }),
    numberColumn<CashCreditRow, Record<string, unknown>>({
        accessorKey: 'initialAmount',
        header: 'Montant initial',
        defaultVisible: true,
    }),
    numberColumn<CashCreditRow, Record<string, unknown>>({
        accessorKey: 'currentAmount',
        header: 'Montant restant',
        defaultVisible: true,
    }),
    dateColumn<CashCreditRow, Record<string, unknown>>({
        accessorKey: 'refundedAt',
        header: 'Date de remboursement',
        defaultVisible: true,
    }),
];

export function TotemCashHistory({
    totemCashHistory,
}: {
    totemCashHistory: GetTotemCashHistoryQuery['totemCashHistory'];
}) {
    const { credits } = totemCashHistory;

    return (
        <DataTable<CashCreditRow>
            columns={columns}
            data={credits}
            filterMode="client"
            getRowId={(row) => row._id || ''}
            disableUrlSync
            autoFocusSearch={false}
        />
    );
}
